import { render, staticRenderFns } from "./detail-declare-customs.vue?vue&type=template&id=2c8be53f"
import script from "./detail-declare-customs.vue?vue&type=script&lang=ts"
export * from "./detail-declare-customs.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports